import React from 'react';
import styled from 'styled-components';

/**
 * This component's purpose is to use small texts which trigger some action, like opening a modal
 * We are using an a tag for such purpose because it's keyboard accessible by default
 *
 * TODO: 🐨
 *  1. add 'active' and 'focus' styles
 *  2. use <Text /> component if it makes sense
 */

const S = {
  TriggerAnchorText: styled.a(props => {
    return `
      color: ${props.theme.colors.goBrand.blue};
      width: 100%;
      height: 100%;
      display: ${props.display || 'inline'};
      align-items: ${props.alignItems || 'center'};
      width: ${props.width || 'auto'};

      a:visited {
        color: ${props.theme.colors.goBrand.blue};
      }
    `;
  }),
};

const TriggerAnchorText: React.FC<{
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  styleProps?: object; // css styles,
  href?: string;
}> = ({children, onClick = () => {}, styleProps = {}, href = '#'}) => {
  return (
    <S.TriggerAnchorText
      href={href}
      onClick={e => {
        if (href === '#') {
          e.preventDefault();
        }
        onClick(e);
      }}
      {...styleProps}
    >
      {children}
    </S.TriggerAnchorText>
  );
};

export default TriggerAnchorText;
